<template>
  <div class="downSj">
    <img src="https://img.yzcdn.cn/upload_files/2020/06/12/Ftjw6LlaZEaCL1VfsSQgEYY7zAQJ.jpg" />
    <div class="middle">
      <img src="https://img.yzcdn.cn/upload_files/2020/06/12/FqBOwO1AkHOkLc_ImOAY-MN6pGcB.jpg" />
      <img class="code" :src="baiduQrcode ? `/cms/upload/baiduQrcode/` + baiduQrcode : ''" />
    </div>

    <div class="bottom">
      <img src="https://img.yzcdn.cn/upload_files/2020/06/12/Fn6oVhsTHJvAD6u1drs8i5AKuUot.jpg" />
      <a href="/cms/webapp/home/info/contactService.html"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      baiduQrcode: ''
    };
  },
  components: {},
  methods: {},
  mounted() {
    console.log(this.$route.query.baiduQrcode);
    this.baiduQrcode = this.$route.query.baiduQrcode;
  }
};
</script>

<style lang="scss" scroped>
.downSj {
  img {
    width: 100%;
  }
  .middle {
    position: relative;
    .code {
      width: 3.7rem;
      position: absolute;
      z-index: 99;
      top: 2.5rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .bottom {
    position: relative;
    a {
      width: 50%;
      height: 1rem;
      position: absolute;
      bottom: 1.4rem;
      left: 3rem;
    }
  }
}
</style>
